import {
  PARSING_JD,
  PARSING_JD_SUCCESSFUL,
  PARSING_JD_FAILED,
  ADD_JOB,
  ADD_JOB_FAILED,
  ADD_JOB_SUCCESSFUL,
  GET_JOB_DATA,
  GET_JOB_DATA_SUCCESSFUL,
  GET_JOB_DATA_FAILED,
  UPDATE_JOB,
  UPDATE_JOB_FAILED,
  UPDATE_JOB_SUCCESSFUL,
  GET_QUALIFICATION,
  GET_QUALIFICATION_SUCCESSFUL,
  GET_QUALIFICATION_FAILED,
  JOB_GET_IP_LOCATION,
  JOB_GET_IP_LOCATION_FAILED,
  JOB_GET_IP_LOCATION_SUCCESSFULL,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATE,
  GET_STATE_FAILED,
  GET_STATE_SUCCESS,
  GET_ORGANIZATION_DETAIL_SUCCESS,
  GET_ORGANIZATION_DETAIL_JOB,
  GET_ORGANIZATION_DETAIL_FAILED,
  GET_TAXONOMY_JOBPROFILE_FAILED,
  GET_TAXONOMY_JOBPROFILE_SUCCESS,
  GET_TAXONOMY_JOBPROFILE,
  GET_TAXONOMY_JOBDESCRIPTION,
  GET_TAXONOMY_JOBDESCRIPTION_FAILED,
  GET_TAXONOMY_JOBDESCRIPTION_SUCCESS,
  GET_TAXONOMY_JOBSKILL,
  GET_TAXONOMY_JOBSKILL_SUCCESS,
  GET_TAXONOMY_JOBSKILL_FAILED,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL,
  RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED,
  BULK_IMPORT_SUGGESTION,
  BULK_IMPORT_SUGGESTION_SUCCESS,
  BULK_IMPORT_SUGGESTION_ERROR,
  ADD_LOCATION,
  ADD_LOCATION_SUCCESSFUL,
  ADD_LOCATION_FAILED,
  GET_JOB_INDUSTRIES,
  GET_JOB_INDUSTRIES_SUCCESS,
  GET_JOB_INDUSTRIES_FAILED,
  GET_JOB_DEGREES,
  GET_JOB_DEGREES_SUCCESS,
  GET_JOB_DEGREES_FAILED,
} from "./actionTypes";

const initialState = {
  parsingJobDataError: null,
  message: null,
  loading: false,
  user: null,
  addJobError: null,
  addNewJobData: null,
  getJobDataError: null,
  jobData: null,
  updateJobData: null,
  updateJobError: null,
  updateJobDataResponse: null,
  getQualificationListError: null,
  getQualificationList: null,
  setIplocationError: null,
  setIplocation: null,
  countriesData: null,
  statesBasedOnCountry: null,
  orgData: null,
  taxnoJobProfile: null,
  taxnoJobProfileError: null,
  taxnoJobDescription: null,
  taxnoJobDescriptionError: null,
  taxnoJobSkill: null,
  taxnoJobSkillError: null,
  organizationDetail: null,
  bulkImportSuggestionData: null,
  bulkImportSuggestionDataError: null,
  getJobRightNow: null,
  locationAdd: null,
  locationFailed: null,
  jobIndustries: null,
  degrees: null,
  degreesError: null,
};

const getParsingJd = (state = initialState, action) => {
  switch (action.type) {
    case PARSING_JD:
      state = {
        ...state,
        loading: true,
        parsingJobDataError: null,
      };
      break;
    case PARSING_JD_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        parsingJobDataError: null,
      };
      break;
    case PARSING_JD_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        parsingJobDataError: action.payload,
      };
      break;
    case ADD_JOB:
      state = {
        ...state,
        loading: true,
        addJobError: null,
      };
      break;
    case ADD_JOB_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        addNewJobData: action.payload,
        addJobError: null,
      };
      break;
    case ADD_JOB_FAILED:
      state = {
        ...state,
        addNewJobData: null,
        loading: false,
        addJobError: action.payload,
      };
      break;
    case GET_JOB_DATA:
      state = {
        ...state,
        loading: true,
        getJobDataError: null,
        getJobRightNow: null,
      };
      break;
    case GET_JOB_DATA_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        jobData: action.payload,
        getJobDataError: null,
        getJobRightNow: action.payload,
      };
      break;
    case GET_JOB_DATA_FAILED:
      state = {
        ...state,
        jobData: null,
        loading: false,
        getJobDataError: action.payload,
        getJobRightNow: null,
      };
      break;
    case UPDATE_JOB:
      state = {
        ...state,
        loading: true,
        updateJobError: null,
      };
      break;
    case UPDATE_JOB_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        updateJobDataResponse: action.payload,
        updateJobError: null,
      };
      break;
    case UPDATE_JOB_FAILED:
      state = {
        ...state,
        updateJobDataResponse: null,
        loading: false,
        updateJobError: action.payload,
      };
      break;
    case GET_QUALIFICATION:
      state = {
        ...state,

        getQualificationList: null,
        getQualificationListError: null,
      };
      break;
    case GET_QUALIFICATION_FAILED:
      state = {
        ...state,
        loading: false,
        getQualificationListError: action.payload,
      };
      break;
    case GET_QUALIFICATION_SUCCESSFUL:
      state = {
        ...state,
        // loading: false,
        getQualificationListError: null,
        getQualificationList: action.payload,
      };
      break;
    case JOB_GET_IP_LOCATION:
      state = {
        ...state,
        setIplocation: null,
        setIplocationError: null,
        loading: true,
      };
      break;
    case JOB_GET_IP_LOCATION_SUCCESSFULL:
      state = {
        ...state,
        setIplocation: action.payload,
        loading: false,
      };
      break;
    case JOB_GET_IP_LOCATION_FAILED:
      state = {
        ...state,
        setIplocationError: action.payload,
        loading: false,
      };
      break;
    case GET_STATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_STATE_SUCCESS:
      state = {
        ...state,
        statesBasedOnCountry: action.payload.user,
        loading: false,
      };
      break;
    case GET_STATE_FAILED:
      state = {
        ...state,
        statesBasedOnCountry: null,
        loading: false,
      };
      break;
    case GET_COUNTRIES:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_COUNTRIES_SUCCESS:
      state = {
        ...state,
        countriesData: action.payload.user,
        loading: false,
      };
      break;
    case GET_COUNTRIES_FAILED:
      state = {
        ...state,
        countriesData: null,
        loading: false,
      };
      break;
    case GET_ORGANIZATION_DETAIL_JOB:
      state = {
        ...state,
        orgData: null,
        loading: true,
      };
      break;
    case GET_ORGANIZATION_DETAIL_SUCCESS:
      state = {
        ...state,
        orgData: action.payload,
        loading: false,
      };
      break;
    case GET_ORGANIZATION_DETAIL_FAILED:
      state = {
        ...state,
        orgData: null,
        loading: false,
      };
      break;
    case GET_TAXONOMY_JOBPROFILE:
      state = {
        ...state,

        taxnoJobProfileError: null,
      };
      break;
    case GET_TAXONOMY_JOBPROFILE_SUCCESS:
      state = {
        ...state,

        taxnoJobProfile: action.payload,
        taxnoJobProfileError: null,
      };
      break;
    case GET_TAXONOMY_JOBPROFILE_FAILED:
      state = {
        ...state,
        taxnoJobProfile: null,

        taxnoJobProfileError: action.payload,
      };
      break;
    case GET_TAXONOMY_JOBDESCRIPTION:
      state = {
        ...state,

        taxnoJobDescriptionError: null,
      };
      break;
    case GET_TAXONOMY_JOBDESCRIPTION_SUCCESS:
      state = {
        ...state,

        taxnoJobDescription: action.payload,
        taxnoJobDescriptionError: null,
      };
      break;
    case GET_TAXONOMY_JOBDESCRIPTION_FAILED:
      state = {
        ...state,
        taxnoJobDescription: null,
        taxnoJobDescriptionError: action.payload,
      };
      break;
    case GET_TAXONOMY_JOBSKILL:
      state = {
        ...state,

        taxnoJobSkillError: null,
      };
      break;
    case GET_TAXONOMY_JOBSKILL_SUCCESS:
      state = {
        ...state,

        taxnoJobSkill: action.payload,
        taxnoJobSkillError: null,
      };
      break;
    case GET_TAXONOMY_JOBSKILL_FAILED:
      state = {
        ...state,
        taxnoJobSkill: null,
        taxnoJobSkillError: action.payload,
      };
      break;
    case RECRUITER_ORGANIZATION_DETAIL_GET_LIST_SUCCESSFULL:
      state = {
        ...state,
        organizationDetail: action.payload,
        organizationError: null,
        loading: false,
      };
      break;
    case RECRUITER_ORGANIZATION_DETAIL_GET_LIST_FAILED:
      state = {
        ...state,
        organizationDetail: null,
        organizationError: action.payload,
        loading: false,
      };
      break;
    //Bulk Import Suggestion

    case BULK_IMPORT_SUGGESTION:
      state = {
        ...state,
        bulkImportSuggestionData: null,
        bulkImportSuggestionDataError: null,
      };
      break;
    case BULK_IMPORT_SUGGESTION_SUCCESS:
      state = {
        ...state,
        updateCandidateStatus: false,
        bulkImportSuggestionData: action.payload,
        bulkImportSuggestionDataError: null,
      };
      break;
    case BULK_IMPORT_SUGGESTION_ERROR:
      state = {
        ...state,
        bulkImportSuggestionDataError: action.payload,
        bulkImportSuggestionData: null,
      };
      break;
    case ADD_LOCATION:
      state = {
        ...state,
        loading: true,
        locationAdd: null,
      };
      break;
    case ADD_LOCATION_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        locationAdd: action.payload,
        locationFailed: null,
      };
      break;
    case ADD_LOCATION_FAILED:
      state = {
        ...state,
        locationAdd: null,
        loading: false,
        locationFailed: action.payload,
      };
      break;
    case GET_JOB_INDUSTRIES:
      state = {
        ...state,
        loading: true,
        jobIndustries: null,
      };
      break;
    case GET_JOB_INDUSTRIES_SUCCESS:
      state = {
        ...state,
        loading: false,
        jobIndustries: action.payload,
      };
      break;
    case GET_JOB_INDUSTRIES_FAILED:
      state = {
        ...state,

        loading: false,
        jobIndustries: null,
      };
      break;
    case GET_JOB_DEGREES:
      state = {
        ...state,
        degrees: null,
        degreesError: null,
      };
      break;
    case GET_JOB_DEGREES_SUCCESS:
      state = {
        ...state,
        degrees: action.payload,
        degreesError: null,
      };
      break;
    case GET_JOB_DEGREES_FAILED:
      state = {
        ...state,
        degrees: null,
        degreesError: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getParsingJd;
